<template>
  <div class="app-wrapper">
    <sidebar />

    <div class="main-container">
      <navbar></navbar>
      <section class="app-main">
        <transition name="fade" mode="out-in">
          <keep-alive :max="6">
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
        </transition>
        <transition name="fade" mode="out-in">
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </transition>
      </section>

      <right-panel>
        <setting />
      </right-panel>

      <image-wall />
      <video-wall />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Navbar, Sidebar, Setting } from './components'
import RightPanel from './components/right-panel'
import ImageWall from './components/image-wall'
import VideoWall from './components/video-wall'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    RightPanel,
    Setting,
    ImageWall,
    VideoWall
  },

  computed: {
    ...mapState({
      showSettings: (state) => state.settings.showSettings
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f1f5f8;

  &::after {
    content: '';
    display: table;
    clear: both;
  }
}

.main-container {
  margin-left: 190px;
  min-height: calc(100vh - 64px);
  background: #f1f5f8;
  transition: margin-left 0.28s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
